import { Link } from 'react-router-dom'
import styles from './Header.module.css'

interface HeaderProps {
  /** Show navigation links. Defaults to false for focused pages like /buy. */
  showNav?: boolean
}

export function Header({ showNav = false }: HeaderProps) {
  return (
    <header className={styles.header} role="banner">
      <div className={`container ${styles.inner}`}>
        <Link to="/" className={styles.wordmark} aria-label="Gesturely — home">
          Gesturely
        </Link>

        {showNav && (
          <nav aria-label="Main navigation">
            <ul className={styles.nav}>
              <li>
                <Link to="/buy" className={styles.navLink}>
                  Buy
                </Link>
              </li>
              <li>
                <a
                  href="mailto:support@getgesturely.com"
                  className={styles.navLink}
                >
                  Support
                </a>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  )
}
